import * as React from 'react';
import './HowToInvest.css';
import TestimonialContainer from 'src/modules/testimonial/Testimonial.container';

const SyndicationSectionComponent: React.StatelessComponent = () => (
  <div>
    <div className="container">
      <div className="gap-20"/>
      <div className="row">
        <div className="col-md-12">
          <h3 className="bold-subtitle">
            ¿Cómo funciona la sindicación de inversores?
          </h3>
        </div>
      </div>
      <div className="gap-30"/>
      <div className="row">
        <div className="col-md-6">
          <div className="col-md-2 text-center">
            <img
              style={{width: '50px', height: '50px'}}
              alt="sindicacion"
              src="/img/sindicacion.svg"
            />
          </div>
          <div className="col-md-10">
            <div className="SyndicationDesc">
              The Crowd Angel ha diseñado conjuntamente con expertos en consultoría e inversión en startups una
              estructura
              de agrupación sindicada que asegura la máxima eficiencia fiscal aprovechando los incentivos existentes, a
              la
              vez que permite negociar las condiciones de la inversión en grupo para tener una mayor fuerza de
              representación en el capital social de la empresa y asegurar que se ofrece una protección adecuada a los
              inversores. Esta estructura también permite ordenar el capital social de la compañía después de la
              inversión,
              facilitando la entrada de nuevos inversores a futuro.
            </div>
          </div>
        </div>
        <div className="col-md-6 padding-left-60">
          <div className="col-md-2 text-center">
            <img
              style={{width: '50px', height: '50px'}}
              alt="sindicaciones"
              src="/img/sindicaciones.svg"
            />
          </div>
          <div className="col-md-8">
            <div className="SyndicationDesc">
              Posteriormente, todas las participaciones propiedad de los inversores se sindican mediante un Contrato de
              Sindicación de Participaciones, que tiene como objetivo principal la toma de decisiones colegiada de todos
              los Crowd Angels en relación a su participada, de acuerdo a los derechos adquiridos en el pacto de socios.
              De esta manera, cualquier decisión que requiera la aprobación de los Crowd Angels en las empresas
              participadas, necesitará una opinión mayoritaria – recogida a través de sistemas de votación online –
              entre
              los Crowd Angels participantes.
            </div>
          </div>
        </div>
      </div>
      <div className="gap-10"/>
      <div className="row">
        <div className="col-md-6">
          <div className="col-md-2 text-center">
            <img
              style={{width: '50px', height: '50px'}}
              alt="deducciones"
              src="/img/deducciones.svg"
            />
          </div>
          <div className="col-md-10">
            <div className="SyndicationDesc">
              Al invertir, los inversores de The Crowd Angel pasan a ser propietarios directos de las participaciones
              adquiridas en el capital social de la compañía mediante su inversión rigiéndose por la <a className="law">
              Ley de sociedades de capital</a>. Esto permite disponer de un título de propiedad y disfrutar de las
              ventajas fiscales existentes
              relacionadas con la inversión en capital en empresas de nueva creación. Puedes informarte de ellas en
              nuestra guía de deducciones fiscales.
            </div>
          </div>
        </div>
        <div className="col-md-6 padding-left-60">
          <div className="col-md-2 text-center">
            <img
              style={{width: '50px', height: '50px'}}
              alt="voto"
              src="/img/voto.svg"
            />
          </div>
          <div className="col-md-8">
            <div className="SyndicationDesc">
              El contrato también regula la relación entre los Crowd Angels en cada participada y su representación en
              la
              empresa, que principalmente consiste en que uno de los inversores actuará como representante del sindicato
              con una posición dentro del Consejo de Administración de la Compañía, y trasladando el voto de la opinión
              mayoritaria del grupo en la Junta de Accionistas.
            </div>
          </div>
        </div>
      </div>
    </div>
    <TestimonialContainer/>

  </div>
);

export default SyndicationSectionComponent;


// WEBPACK FOOTER //
// ./src/modules/how-to-invest/partials/SyndicationSection.component.tsx